import { io } from 'socket.io-client';

const serverUrl = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:5001';

const options = {
  reconnectionAttempts: 'Infinity',
  timeout: 10000,
  transports: ['websocket'],
};

// 싱글톤으로 인스턴스 관리 — 앱 전체에서 하나의 소켓 연결 공유
const socket = io(serverUrl, options);

// 로그인 후 JWT 토큰을 소켓 인증에 적용 (admin 명령 사용 가능)
export const setSocketAuth = (token) => {
  socket.auth = { token };
  socket.disconnect().connect();
};

export default socket;
